import React from 'react';
import TestimonialCard from './TestimonialCard';

interface Props {
    testimonials?: any;
    videoLink?: string;
}

const TestimonialList = ({ testimonials, videoLink }: Props) => {
    const sliced = testimonials?.slice(0, 3) ?? [];
    return (
        <div className='default-px mt-0 lg:mt-10 w-full'>
            <div className='mx-auto default-max-w '>
                <div className='grid grid-cols-1 lg:grid-cols-3 auto-rows-max gap-8 justify-items-center justify-center'>
                    {sliced.map((testimonials, index) => {
                        return (
                            <TestimonialCard
                                testimonial={testimonials}
                                key={index}
                                className='min-h-[80px] lg:min-h-[106px]'
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default TestimonialList;
